import SupportCategories from 'Vue/containers/SupportCategories.vue';
import { createApp } from "vue";

let module:any = {};

/**
 * Instantiate Vue Application
 */
module.supportCategoriesVueApp = function () {
	// @ts-ignore
	const sc = createApp(SupportCategories);
	sc.mount("#supportCategories");
};


module.init = function () {
	module.supportCategoriesVueApp();
};

document.addEventListener("DOMContentLoaded", () => {
	module.init();
});
